import { useContext } from 'react';
import { RegistrationContext } from 'contexts/registrationContext/RegistrationContext';

export const useRegistrationContext = () => {
	return useContext(RegistrationContext);
};
